class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.hoverTimeout = null;
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    
    // Add hover events
    cartLink.addEventListener('mouseenter', () => {
      clearTimeout(this.hoverTimeout);
      this.open(cartLink);
    });

    // cartLink.addEventListener('focus', () => {
    //   clearTimeout(this.hoverTimeout);
    //   this.open(cartLink);
    // });

    cartLink.addEventListener('mouseleave', () => {
      this.hoverTimeout = setTimeout(() => {
        this.close();
      }, 300); // 300ms delay before closing
    });

    // Add hover events to the popup itself
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.hoverTimeout);
    });

    this.addEventListener('mouseleave', () => {
      this.hoverTimeout = setTimeout(() => {
        this.close();
      }, 300);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }
    
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    this.querySelectorAll('button.cart-notification__close')[0].focus();

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (this.preventNotification === true || this.preventNotification === 'true') {
      return;
    }

    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `.js-contents`,
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-popup-subtotal',
        section: 'cart-popup-subtotal',
        selector: '#cart-popup-subtotal-content',
      },
      {
        id: 'cart-popup-free-shipping',
        section: 'cart-popup-free-shipping',
        selector: '#cart-popup-free-shipping-content',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

class CartNotificationItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-popup-subtotal',
        section: 'cart-popup-subtotal',
        selector: '#cart-popup-subtotal-content',
      },
      {
        id: 'cart-popup-free-shipping',
        section: 'cart-popup-free-shipping',
        selector: '#cart-popup-free-shipping-content',
      },
    ];
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=cart-notification-product`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('.js-contents');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => {
        return section.section;
      }),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`CartNotificationQuantity-${line}`);
        const items = document.querySelectorAll('.cart-item--notification');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartNotificationWrapper = document.querySelector('cart-notification');

        if (cartNotificationWrapper) cartNotificationWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartNotificationItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartNotificationWrapper
            ? trapFocus(cartNotificationWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartNotificationWrapper) {
          trapFocus(cartNotificationWrapper.querySelector('.cart-notification'), cartNotificationWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartNotificationWrapper) {
          trapFocus(cartNotificationWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch((e) => {
        console.log(e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors') ||
          document.getElementById('cart-notification-errors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
}

customElements.define('cart-notification-items', CartNotificationItems);
